import { render } from "./gsggDetail.vue?vue&type=template&id=7762e33b&scoped=true&ts=true"
import script from "./gsggDetail.vue?vue&type=script&lang=ts"
export * from "./gsggDetail.vue?vue&type=script&lang=ts"

import "./gsggDetail.vue?vue&type=style&index=0&id=7762e33b&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7762e33b"]])

export default __exports__